export default __webpack_public_path__ + "static/media/photo-content-1.3d142d4c.png";